/**
 * Splash-screen dismissal.
 *
 * capacitor.config.ts sets `launchAutoHide: false`, meaning the native
 * splash stays visible until we explicitly call `SplashScreen.hide()`.
 * We do it once, on mount, with a short fade-out — matches the premium
 * feel we want and gives the WebView a beat to hydrate first-paint.
 *
 * On web (no Capacitor) this is a no-op via the dynamic import fallback,
 * so nothing crashes and nothing renders.
 */
import { isNative } from './platform';

let _hidden = false;

export async function hideSplashWithFade() {
  if (_hidden) return;
  if (!isNative()) {
    _hidden = true;
    return;
  }
  try {
    const mod = await import('@capacitor/splash-screen');
    // 500 ms fade — long enough to feel intentional, short enough to
    // not feel sluggish.
    await mod.SplashScreen.hide({ fadeOutDuration: 500 });
    _hidden = true;
  } catch (_err) {
    _hidden = true;
  }
}
